export function digitsOnly(input: string, prefix?: string) {
  const d = input.replace(/\D/g, '');
  return prefix ? `${prefix}${d}` : `${d}`;
}

export function nanpDigits(input: string) {
  const d = digitsOnly(input);
  const withoutCountryCode = d.length > 10 && d.startsWith('1') ? d.slice(1) : d;
  return withoutCountryCode.slice(0, 10);
}

export function formatNanpPhone(input: string) {
  const d = nanpDigits(input);
  const a = d.slice(0, 3);
  const b = d.slice(3, 6);
  const c = d.slice(6, 10);

  if (d.length <= 3) return a;
  if (d.length <= 6) return `(${a}) ${b}`;
  return `(${a}) ${b}-${c}`;
}

export function isValidNanpDigits(digits10: string) {
  if (!/^\d{10}$/.test(digits10)) return false;
  // NANP: NXX-NXX-XXXX where N=2-9, X=0-9
  if (digits10[0] < '2') return false; // area code can't start 0/1
  if (digits10[3] < '2') return false; // exchange can't start 0/1
  return true;
}

export function toE164FromNanp(input: string) {
  const d = nanpDigits(input);
  return `+1${d}`;
}
